import React from 'react'
import Link from 'next/link'
import styles from './SubMenuFeature.module.scss'
import Image from 'next/image'
import { Heading } from '~elements'
import BackgroundGradientBlur from '../BackgroundGradientBlur/BackgroundGradientBlur'
import { NEXT_IMAGE_QUALITY } from '~constants'
import { AssetType } from '~types'

type SubMenuFeatureType = {
  url: string
  image: AssetType
  title: string
  subtitle?: string
}

export const SubMenuFeature = ({ url, image, title, subtitle }: SubMenuFeatureType) => {
  if (!image?.url || !url || !title) return null

  return (
    <div className={styles['submenu__feature']}>
      <Link href={url} className={styles['feature-link']}>
        <div className={styles['feature-wrapper']}>
          {image?.url && (
            <Image
              src={image?.url}
              alt={image?.altText || ''}
              width={256}
              height={160}
              priority
              quality={NEXT_IMAGE_QUALITY}
            />
          )}
          <div className={styles['feature-copy']}>
            {title && <Heading level={4}>{title}</Heading>}
            {subtitle && <p>{subtitle}</p>}
          </div>
        </div>
      </Link>
      <BackgroundGradientBlur />
    </div>
  )
}
